const { QuorumDataType } = DjangIO.app.models

export const tabLabels = {
    OVERVIEW_TAB: "Overview",
    LISTS_TAB: QuorumDataType.new_list.plural,
    CUSTOM_DATA_TAB: "Custom Data",
    NOTES_TAB: QuorumDataType.note.plural,
    STAFFERS_TAB: QuorumDataType.staffer.plural,
    GRASSROOTS_ACTIONS_TAB: QuorumDataType.grassroots_action.plural,
    DOCUMENTS_TAB: QuorumDataType.document.plural,
    BILLS_TAB: QuorumDataType.bill.plural,
    AMENDMENTS_TAB: QuorumDataType.amendment.plural,
    VOTES_TAB: QuorumDataType.vote.plural,
    COMMITTEES_TAB: QuorumDataType.committee.plural,
    CAUCUSES_TAB: QuorumDataType.caucus.plural,
    CONTACTS_TAB: QuorumDataType.supporter.plural,
    ALL_STATS_TAB: "All Stats",
    LEGISLATIVE_TAB: "Legislative",
    DISTRICT_TAB: "District",
    ISSUES_TAB: QuorumDataType.issue.plural,
    RELATIONSHIPS_TAB: "Relationships",
    STATS_TAB: "Stats",
    STAKEHOLDERS_TAB: "Stakeholders",
    EVENTS_TAB: QuorumDataType.event.plural,
    NEWS_TAB: "News",
    OUTLETS_TAB: "Outlets",
    ARTICLES_TAB: "Articles",
    CAMPAIGN_FINANCE_TAB: "Campaign Finance",
}

export const committeeTabPermanentFilters = {
    official: "associated_with_committee_puborgs",
    event: "associated_with_committees",
    document: "source_committees_or_mentions",
    bill: "from_committees",
    amendment: "from_committees",
    staffer: "staffers_associated_with_committee_puborgs",
    committee: "committee",
}

export const profileLimits = {
    memberLimit: 6,
}

export const profileForms = {
    committee: "committeeForm",
}

export const CUSTOM_EVENT_PROFILE_DTV_WIDTH = 3

export const issueAdderExtraFields = {
    isLeaf: "_isLeaf",
    tentativelyAdded: "_tentativelyAdded",
    tentativelyRemoved: "_tentativelyRemoved",
}

// These constants are used to determine the style of the DTV elements within a section
export const DTV_STYLE_CONSTANTS = {
    CARD: "DTV_CARD",
    RAW_CARD: "RAW_CARD",
    ELEMENT: "DTV_ELEMENT_STANDARD",
    MINIMAL: "DTV_ELEMENT_MINIMAL",
}

// The number of characters before a bill title is considered very long
export const LONG_HEADER_TITLE_LIMIT = 90
